import EmberObject from '@ember/object';

export function computeFromComponentValues(c1, c2, c5, r1, r2) {
  var gain = c1 / c5;
  var sqrtTerm = Math.sqrt(r1 * r2 * c2 * c5);
  var fpPrime = 1 / (2 * Math.PI * sqrtTerm);
  var woPrime = 1 / sqrtTerm;

  var q = 1 / ((c1 + c2 + c5) / (c2 * c5 * r2 * woPrime));
  var fp = fpPrime;

  var result = EmberObject.create({ stageQ: q, stageFp: fp, gain: gain });
  return result;
}

export function execute(circuit) {
  var r1 = circuit.r1.value;
  var r2 = circuit.r2.value;
  var c1 = circuit.c1.value;
  var c2 = circuit.c2.value;
  var c5 = circuit.c5.value;
  return computeFromComponentValues(c1, c2, c5, r1, r2);
}
